import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { CalenderIcon } from "../../Icon";

type AppProps = {
  startDate?: string;
  endDate?: string;
  handleStartDateChange?: (date: string) => void;
  handleEndDateChange?: (date: string) => void;
  handleSubmitData?: () => void;
};


const DailyUserHeader = ({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData
}: AppProps) => {

  return <>

    <div className='d-flex justify-content-center pt-5'>
      <div className="col-md-3">
        <div className="form-group">
          <div className='date-picker-wraper mr-0'>
            <Label className='m-0 p-0 w-100'>
              <ReactDatePicker
                dateFormat="dd-MM-yyyy"
                selected={startDate ? new Date(moment(`${ startDate }T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                onChange={(e: any) => { handleStartDateChange?.(moment(e).format('YYYY-MM-DD')) }}
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name='dateOfInvoice'
                placeholderText='Start Date'
                className='form-control'
              />
              <span className="calender-icon" style={{ right: '30px', cursor: 'pointer' }}>
                <CalenderIcon />
              </span>
            </Label>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-group">
          <div className='date-picker-wraper mr-0'>
            <Label className='m-0 p-0 w-100'>
              <ReactDatePicker
                dateFormat="dd-MM-yyyy"
                selected={endDate ? new Date(moment(`${ endDate }T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                onChange={(e: any) => { handleEndDateChange?.(moment(e).format('YYYY-MM-DD')) }}
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name='dateOfInvoice'
                placeholderText='End Date'
                className='form-control'
              />
              <span className="calender-icon" style={{ right: '30px', cursor: 'pointer' }}>
                <CalenderIcon />
              </span>
            </Label>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <button
          className="btn btn-primary"
          onClick={handleSubmitData}
          disabled={!startDate?.length || !endDate?.length}
        >
          Get Data
        </button>
      </div>
    </div>

  </>
}


export default DailyUserHeader;